import React, { Component } from "react";
import Footer from "../footer/footer";
import HeaderNew from "../header/header";
import { Link } from "react-router-dom";
import pic from '../assets/pr2.jpg';
import dots from "../assets/dots.png"
import mailicon from '../assets/mail.png'

import './profile.css'

class Author extends Component {
    constructor() {
        super()
        this.state = {
            tabselect: 'overview',
            edit: false
        }
    }
    render() {
        const profile = {
            "name": "Danny Sapio",
            "bio": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "profession": "Counsillor",
            "affiliation": 'Oxford University, UK',
            "email": "dannysapio@gmail.com"
        }
        return (
            <div>
                <HeaderNew />
                <div className='container'>
                    <div className='row-profile'>
                        <div className='img-cont'>
                            <div className='width-90'>
                                <img src={pic} className='profile-img' />
                                <div className='profile-name'>{profile.name}</div>
                                <p className='profile-details'>{profile.bio}</p>
                                <p className='profile-affl'>{profile.profession} at {profile.affiliation}</p>
                                <a href='www.mail.google.com'><img className='mailicon' src={mailicon} />  {profile.email}</a>
                            </div>
                        </div>
                        <div className="other-cont">
                            <div className='profile-tab'>
                                <div className='tabselect' style={{ borderBottomColor: "#165E84", color: "#165E84" }}>Publications</div>
                            </div>
                            <div className='pub-container'>
                                <div className='works'>
                                    <div className='rows'>
                                        <div className='title'>Transforming Qatar into A Circular Economy: Challenges and Opportunities and the Role of Islamic Finance</div>
                                        <div className='work-type'>Thesis</div>
                                    </div>
                                    <p className='body'>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                    </p>
                                    <p className='date'>10.08.2021</p>
                                </div>
                                <div className='works'>
                                    <div className='rows'>
                                        <div className='title'>Transforming Qatar into A Circular Economy: Challenges and Opportunities and the Role of Islamic Finance</div>
                                        <div className='work-type'>Thesis</div>
                                    </div>
                                    <p className='body'>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                    </p>
                                    <p className='date'>10.08.2021</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Author;